module.exports = __webpack_public_path__ + "3c7f55a5cc2cd281.png";